import React from 'react';

const LoadingSpinner = () => {
  const className = 'spinner';
  const radius = 40;
  const baseColor = '#cccccc';
  const baseWidth = 20;
  const barColor = '#35aae3';
  const innerWidth = baseWidth;

  return (
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      className={className}
    >
      <circle
        className="background"
        cx="50"
        cy="50"
        fill="none"
        r={radius}
        stroke={baseColor}
        strokeWidth={baseWidth}
      />
      <circle
        className="foreground"
        cx="50"
        cy="50"
        fill="none"
        r={radius}
        stroke={barColor}
        strokeWidth={innerWidth}
        strokeLinecap="square"
        transform="rotate(144 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;180 50 50;720 50 50"
          keyTimes="0;0.5;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dasharray"
          calcMode="linear"
          values="25.132741228718345 226.1946710584651;125.66370614359172 125.66370614359172;25.132741228718345 226.1946710584651"
          keyTimes="0;0.5;1"
          dur="1"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

export default LoadingSpinner;
